// Module
var code = `<div appHeaderBar>
    <header-bar-title>Existing Profile Found</header-bar-title>
</div>

<app-page-content [showWebFooter]="true" [usePagePadding]="true">
    <div class="existing-sso-profile-merge__back">
        <button type="button" class="existing-sso-profile-merge__back-link" (click)="returnToPrevious()">
            <span aria-hidden="true">&larr;</span> Return to Previous
        </button>
    </div>

    <div class="HOA-container">
        <div class="HOA-container__header">
            <div class="existing-sso-profile-merge__heading">
                <h1 class="HOA-container__header-text">Existing Profile Found</h1>
                <p class="existing-sso-profile-merge__sub-header">
                    Check your inbox for a one-time pass code and enter below.
                </p>
            </div>
        </div>

        <div class="HOA-container__content">
            <form [formGroup]="form" (ngSubmit)="merge()">
                <div class="existing-sso-profile-merge__row">
                    <div class="Field existing-sso-profile-merge__code" [class.is-invalid]="showError">
                        <input
                                type="text"
                                class="Input existing-sso-profile-merge__input"
                                id="passcode"
                                aria-label="One-time passcode"
                                placeholder="Enter your passcode"
                                inputmode="numeric"
                                maxlength="6"
                                formControlName="code"
                                (input)="onCodeInput(\$event)"
                                [attr.aria-invalid]="showError"
                                [attr.aria-describedby]="showError ? 'passcode-error' : null"
                        />
                        <span class="Field-error" id="passcode-error">{{ errorMessage }}</span>
                    </div>
                    <button type="submit" class="HOA-splash-buttons-container__button Button Button--blue" [disabled]="mergeDisabled">
                        Merge Profile
                    </button>
                </div>
            </form>

            <p class="existing-sso-profile-merge__resend">
                Didn&rsquo;t get it?
                <a href="#" (click)="resendCode(\$event)">Send new pass code to email</a>
            </p>

            <output *ngIf="resent" class="existing-sso-profile-merge__note">
                A new passcode has been sent.
            </output>

            <p *ngIf="lockedOut" class="existing-sso-profile-merge__lockout" role="alert">
                Too many attempts. Please request a new pass code to continue.
            </p>
        </div>
    </div>
</app-page-content>
`;
// Exports
module.exports = code;